var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-link',{staticClass:"count",attrs:{"to":"/cart"}},[_c('i',{staticClass:"fa fa-shopping-cart",attrs:{"aria-hidden":"true"}}),_c('p',[_vm._v(_vm._s(_vm.cnt))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }